import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="bg-gradient-to-b from-dark via-dark to-darkGray py-20 md:py-32 px-4 md:px-8 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-red-500/10 rounded-full blur-3xl -z-10"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-red-500/5 rounded-full blur-3xl -z-10"></div>
      
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-block badge-primary">
                Bangladesh's #1 Sports Community
              </div>
              
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight tracking-tight">
                Find Matches & <span className="text-gradient">Play</span> Across Bangladesh
              </h1>
              
              <p className="text-gray-300 text-lg max-w-md leading-relaxed">
                Connect with players in Dhaka, Chittagong, Sylhet and beyond. Discover local matches, join games instantly, and build your sports network.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Link to="/register" className="btn-primary text-center">
                Get Started
              </Link>
              <Link to="/login" className="btn-secondary-white text-center">
                Explore Matches
              </Link>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-gray-800">
              <div>
                <div className="text-3xl font-bold text-red-500">10K+</div>
                <p className="text-gray-400 text-sm">Players</p>
              </div>
              <div>
                <div className="text-3xl font-bold text-red-500">500+</div>
                <p className="text-gray-400 text-sm">Matches</p>
              </div>
              <div>
                <div className="text-3xl font-bold text-red-500">50+</div>
                <p className="text-gray-400 text-sm">Cities</p>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="hidden md:block">
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-red-500/30 to-transparent rounded-3xl blur-3xl group-hover:blur-2xl transition-all duration-300"></div>
              <img
                src="https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=600&h=400&fit=crop"
                alt="Football field"
                className="w-full h-96 object-cover rounded-3xl shadow-2xl relative z-10 group-hover:shadow-glow-red-lg transition-all duration-300"
              />
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-t from-dark/40 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
